module.exports = __webpack_public_path__ + "img/_MG_3700.a732ff30.jpg";